/*
	Obbligatori:
		headerName
		field
	Facoltativi:
		width
*/

export default function SaitPercentageColumn(props) {
	return {
		headerName: props.headerName,
		width: props.width,
		field: props.field,
		hidden: props.hidden || false,
		flex: props.flex,
		columnType: "percentage",
		type: "number",
		renderCell: props.renderCell,
		startPinned: props.startPinned,
		endPinned: props.endPinned,
		valueFormatter: (value, row, column, apiRef) => {
			if (props.showZero) {
				return `${Math.round(value * 100) / 100 || 0} %`;
			} else {
				return value || value === 0 ? `${Math.round(value * 100) / 100} %` : value;
			}
		},
		objmod: props.objmod,
	};
}
